import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import podetailImage from "../../assests/images/Po details.png";
import summaryImage from "../../assests/images/Summary.png";
import { purchaseInvoiceServices } from "../../services/purchaseInvoiceServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import TableListing from "../common/tableListing";
import { isEmptyDash, returnRateVal, strToDate, totalInr } from "../../constant";
import P2PDownload from "../common/p2pDownload";

const initialColumns = [
  { id: "poNumber", label: "PO Number", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  // { id: "purchaseInvoiceId", label: "Purchase Invoice Id", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  // { id: "purchaseOrderId", label: "PO Id", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "material", label: "Material", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "hsnSacCode", label: "HSN/SAC Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "quantity", label: "Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "glAccount", label: "GL Account", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "createdAt", label: "Created On", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  { id: "updatedAt", label: "Updated On", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  { id: "taxCode", label: "Tax Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "taxAmt", label: "Tax Amount", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
  { id: "invoicingParty", label: "Invoicing Party", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "amount", label: "Amount", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const steps = [
  {
    label: "PO Creation",
    text: "Created on : 12-02-2024",
    description: `Created At : 10:00`,
    remarks: `Created By : Sanjeev`,
  },
  {
    label: "PO Approval",
    text: "Approved on : 12-02-2024",
    description: `Approved By : Sanjeev`,
  },
  {
    label: "QC Creation : QC0001, QC0002",
    headings: "QC0001",
    text: "Approved on : 12-02-2024",
    remarks: "QC Created At : 10:00",
    description: `Approved By : Sanjeev`,
    headings2: "QC0002",
    remarks2: "QC Created on : 12-02-2024",
    description2: "QC Created At : 10:00",
    text2: "QC Created By : Sanjeev"
  },
  {
    label: "LR Creation : LR0001, LR0002",
    headings: "LR0001",
    text: "LR Created on : 12-02-2024",
    remarks: "LR Created At : 10:00",
    description: `LR Created By : Sanjeev`,
    headings2: "LR0002",
    remarks2: "LR Created on : 12-02-2024",
    description2: "LR Created At : 10:00",
    text2: "LR Created By : Sanjeev"
  },
  {
    label: "QC Creation : QC0003, QC0004",
    headings: "QC0003",
    text: "QC Created on : 12-02-2024",
    remarks: "QC Created At : 10:00",
    description: `QC Created By : Sanjeev`,
    headings2: "QC0004",
    remarks2: "QC Created on : 12-02-2024",
    description2: "QC Created At : 10:00",
    text2: "QC Created By : Sanjeev"
  },
  {
    label: "LR Delivered : LR0001, LR0002",
    headings: "LR0001",
    text: "LR Created on : 12-02-2024",
    remarks: "LR Created At : 10:00",
    description: `LR Created By : Sanjeev`,
    headings2: "LR0004",
    remarks2: "LR Created on : 12-02-2024",
    description2: "LR Created At : 10:00",
    text2: "LR Created By : Sanjeev"
  },
  {
    label: "Gate Creation : GE0001, GE0002",
    headings: "GE0001",
    text: "GE Created on : 12-02-2024",
    remarks: "GE Created At : 10:00",
    description: `GE Created By : Sanjeev`,
    headings2: "GE0002",
    remarks2: "GE Created on : 12-02-2024",
    description2: "GE Created At : 10:00",
    text2: "GE Created By : Sanjeev"
  },
  {
    label: "GRN Creation : GRN0001, GRN0002",
    headings: "GRN0001",
    text: "GRN Created on : 12-02-2024",
    remarks: "GRN Created At : 10:00",
    description: `GRN Created By : Sanjeev`,
    headings2: "GRN0002",
    remarks2: "GRN Created on : 12-02-2024",
    description2: "GRN Created At : 10:00",
    text2: "GRN Created By : Sanjeev"
  },

  // Add more steps if needed...
];

function PurchaseDetail() {
  const { id } = useParams();
  const [openpopdfpurchasemodal, setOpenPoPdfPurchaseModal] = useState(false);
  const [openpopdfpurchasesuccessmodal, setOpenPoPdfPurchaseSuccessModal] =
    useState(false);
  const [openasnsubmitsuccessfully, setOpenAsnSubmitSuccessfullys] =
    useState(false);
  const [PIDetails, setPIDetails] = React.useState({});
  const [openasncancelsuccessfully, setOpenAsnCancelSuccessfullys] =
    useState(false);
  const [productsListing, setProductsListing] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    products: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  useEffect(() => {
    getDetails(id);
    // let secGRNPermissionInit = _.cloneDeep(secGRNPermission);
    // let obj = {};
    // for (let key in secGRNPermissionInit) {
    //   obj[key] = getSecPermission(key);
    // }
    // // console.log(obj);
    // setSecGRNPermission(obj);
  }, []);
  
  const getDetails = (param) => {
    setIsLoading(true);
    let url = `/${param}`;
    let promise = purchaseInvoiceServices.getPurchaseInvoiceListing(url);
    promise.then((res) => {
      if (res.data.success === true) {
        setPIDetails(res.data?.data);
        // setPurchaseOrderID(res?.data?.data?.purchaseOrderIds[0]);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const dummyFun = (param) => {  };
  
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerse ms-auto">
            <div className="search_mains">
              <h5>Purchase Invoice Booking Details</h5>
            </div>
            
              <P2PDownload
                url={`/v1/common/purchase-invoices/download`}
                selectedArr={[id]}
                selectedPOJsonArr={[PIDetails]}
                filterFormData={{invoiceNumber: PIDetails?.invoiceNumber}}
                filterText={""}
                type="Purchase_Invoice"
              />
            
          </div>

          <div className="lets_head_purchase_number_buyer_react_blocklist">
            <div className="first_podetail_basic_block_level_reacts">
              <div className="lets_react_order_listing_level_buyer">
                <div className="content_react_level_details">
                  <img src={podetailImage} alt="" />
                  <p className="lets_block_react_details_purchase">
                    Purchage Invoice Number : {PIDetails?.invoiceNumber}
                  </p>
                </div>
                <div className="lets_pending_react_body">
                  Order Date :
                  <span className="date_solutions"> {strToDate(PIDetails?.createdAt) } </span>
                  {/* <div className="solution_asen_statsu_pending">
                    Status :<p className="date_solutions_status">{PIDetails?.status}</p>
                  </div> */}
                </div>
              </div>
              <div className="lets_table_buyername_react_suntech">
                <table>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Fiscal Year
                    </td>
                    <td>:</td>
                    <td>{PIDetails?.fiscalYear}</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Posting Date
                    </td>
                    <td>:</td>
                    <td>{strToDate(PIDetails?.postingDate)}</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Created By
                    </td>
                    <td>:</td>
                    <td>{PIDetails?.createdBy}</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Company Code
                    </td>
                    <td>:</td>
                    <td>{PIDetails?.sdaasasasas}</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Vendor Name
                    </td>
                    <td>:</td>
                    <td>{PIDetails?.vendorName}</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Vendor Code
                    </td>
                    <td>:</td>
                    <td>{PIDetails?.vendorCode}</td>
                  </tr>
                </table>
                <table>
                  <tr>
                    <td>Currency</td>
                    <td>:</td>
                    <td>{PIDetails?.currency}</td>
                  </tr>
                  <tr>
                    <td>Tax Code</td>
                    <td>:</td>
                    <td>{PIDetails?.taxCode}</td>
                  </tr>
                  <tr>
                    <td>Terms of Payment</td>
                    <td>:</td>
                    <td>{PIDetails?.termsOfPayment}</td>
                  </tr>
                  <tr>
                    <td>Base Line Payment Date</td>
                    <td>:</td>
                    <td>{strToDate(PIDetails?.baseLinePaymentDate)}</td>
                  </tr>
                  <tr>
                    <td>GST Partner</td>
                    <td>:</td>
                    <td>{PIDetails?.gstPartner}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="second_podetail_basic_block_level_reacts">
              <div className="lets_react_order_listing_level_buyer">
                <div className="content_react_level_details">
                  <img src={summaryImage} alt="" />
                  <p className="lets_block_react_details_purchase">Summary</p>
                </div>
              </div>
              <div>
                <table>
                  <tr>
                    <td className="name_asn_details_suntech_react">
                      Gross Invoice Amount
                    </td>
                    <td>:</td>
                    <td>
                      {returnRateVal(PIDetails?.grossInvoiceAmount)}
                      {/* ₹{totalInr(isEmptyDash(PIDetails?.grossInvoiceAmount)? "0": PIDetails?.grossInvoiceAmount)} */}
                      </td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">
                      Value Added Tax (VAT) Amount
                    </td>
                    <td>:</td>
                    <td>
                    {returnRateVal(PIDetails?.valueAddedTaxAmount)}
                      {/* ₹{totalInr(isEmptyDash(PIDetails?.valueAddedTaxAmount)? "0": PIDetails?.valueAddedTaxAmount)} */}
                      </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          
          <TableListing
                column={initialColumns}
                listingArrName="products"
                filterKeyName="INVOICE"
                componentName="PI_LIST"
                promiseRequest={purchaseInvoiceServices?.getPIProductList}
                onFilterChange={dummyFun}
                promiseUrlType="DETAILS"
                detailsId={id}
                additionalData={{
                  isTrackOrder: false,
                  isFilter: false,
                  isSearch: true,
                  isPagePerSize: true,
                  isPagination: true,
                  isDragable: true,
                }}
            />
          
          {/* Submit sucessfully Modal  */}
          {/* <Modal
            open={openasnsubmitsuccessfully}
            onClose={() => setOpenAsnSubmitSuccessfullys(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenAsnSubmitSuccessfullys(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="approvel_btn_successfully">
                    <img src={checkcircleImage} alt="" />
                    <p className="profile_react_block">
                      Selected ASN has been "<b>Submited</b>" Successfully
                    </p>
                    <p className="profile_react_blocks">
                      ASN No. :<b> 07001 |</b> ASN Qty : <b>12</b>
                    </p>
                    <button
                      className="view_progresse"
                      onClick={() => setOpenAsnSubmitSuccessfullys(false)}
                    >
                      Ok
                    </button>
                  </div>
                </form>
              </div>
            </Box>
          </Modal> */}
          {/* Cancel sucessfully Modal  */}
          {/* <Modal
            open={openasncancelsuccessfully}
            onClose={() => setOpenAsnCancelSuccessfullys(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenAsnCancelSuccessfullys(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="approvel_btn_successfully">
                    <img src={rejectImage} alt="" />
                    <p className="profile_react_block">
                      Selected ASN has been "<b>Cancel</b>" Successfully
                    </p>
                    <p className="profile_react_blocks">
                      ASN No. :<b> 07001 |</b> ASN Amount : <b>₹35,600 |</b> ASN
                      Qty : <b>12</b>
                    </p>
                    <button
                      className="view_progresse"
                      onClick={() => setOpenAsnCancelSuccessfullys(false)}
                    >
                      Ok
                    </button>
                  </div>
                </form>
              </div>
            </Box>
          </Modal> */}
          {/* PO PDF Modal Buyer Po */}

          {/* <Modal
            open={openpopdfpurchasemodal}
            onClose={() => setOpenPoPdfPurchaseModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenPoPdfPurchaseModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_Manager_bidding">
                  Are you sure you want to download PO Pdf
                  <br />
                  <b>PO No. : 00701 </b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenPoPdfPurchaseModal(false);
                      setOpenPoPdfPurchaseSuccessModal(true);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => {
                      setOpenPoPdfPurchaseModal(false);
                      setOpenPoPdfPurchaseRejectedModal(true);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/* PO PDF Successfully Modal Buyer Po */}

          {/* <Modal
            open={openpopdfpurchasesuccessmodal}
            onClose={() => setOpenPoPdfPurchaseSuccessModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenPoPdfPurchaseSuccessModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkImage} alt="" />
                <p class="project_Manager_bidding">
                  Selected PO has been "<b>PDF Download</b>" Successfully
                  <br />
                  <b>PO No. : 07001 </b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenPoPdfPurchaseSuccessModal(false);
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          
        </div>
        
      </div>
      
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default PurchaseDetail;
